/*=============================================== Dropdown ===============================================*/
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/*==================== Imports ====================*/
import React from "react";
import styled from "styled-components";
import Variables from "./Variables";
import Mixins from "./Mixins";
import Flexbox from "./Flexbox";
/*==================== Styles ====================*/
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    top: 42px;\n    ", ";\n    min-width: 200px;\n    background-color: ", ";\n    border-radius: ", ";\n    overflow: hidden;\n    box-shadow: ", ";\n    max-height: ", ";\n    transition: ", ";\n    z-index: 50;\n\n    a,\n    button {\n        color: ", ";\n        text-decoration: none;\n        text-align: left;\n        background-color: transparent;\n        border: none;\n        padding: ", " ", ";\n        transition: ", ";\n\n        @media ", " {\n            &:hover {\n                background-color: ", ";\n                color: ", ";\n            }\n\n            &:active {\n                background-color: ", ";\n                color: ", ";\n            }\n        }\n    }\n"], ["\n    position: absolute;\n    top: 42px;\n    ", ";\n    min-width: 200px;\n    background-color: ", ";\n    border-radius: ", ";\n    overflow: hidden;\n    box-shadow: ", ";\n    max-height: ", ";\n    transition: ", ";\n    z-index: 50;\n\n    a,\n    button {\n        color: ", ";\n        text-decoration: none;\n        text-align: left;\n        background-color: transparent;\n        border: none;\n        padding: ", " ", ";\n        transition: ", ";\n\n        @media ", " {\n            &:hover {\n                background-color: ", ";\n                color: ", ";\n            }\n\n            &:active {\n                background-color: ", ";\n                color: ", ";\n            }\n        }\n    }\n"])), Mixins.Grid({}), Variables.Colors.White, Variables.Radiuses.M, Variables.Shadows.M, function (_a) {
    var $isOpen = _a.$isOpen;
    return ($isOpen ? "800px" : 0);
}, Variables.Transitions.Long, Variables.Colors.Primary500, Variables.Spacers.XS, Variables.Spacers.S, Variables.Transitions.Short, Variables.Breakpoints.Hover, Variables.Colors.Primary300, Variables.Colors.White, Variables.Colors.Primary600, Variables.Colors.White);
var StyledContainer = styled(Flexbox)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    position: relative;\n\n    ", " {\n        left: ", ";\n        right: ", ";\n    }\n"], ["\n    position: relative;\n\n    ", " {\n        left: ", ";\n        right: ", ";\n    }\n"
    /*==================== Component ====================*/
])), Container, function (_a) {
    var $justify = _a.$justify;
    return $justify === "left" && 0;
}, function (_a) {
    var $justify = _a.$justify;
    return $justify === "right" && 0;
});
/*==================== Component ====================*/
var DropdownContainer = function (_a) {
    var _b = _a.justify, justify = _b === void 0 ? "left" : _b, children = _a.children, props = __rest(_a, ["justify", "children"]);
    return (React.createElement(StyledContainer, __assign({ "$justify": justify, justify: justify === "right" ? "flex-end" : "flex-start" }, props), children));
};
var Dropdown = function (_a) {
    var children = _a.children, isOpen = _a.isOpen, props = __rest(_a, ["children", "isOpen"]);
    return (React.createElement(Container, __assign({ "$isOpen": isOpen }, props), children));
};
export { DropdownContainer, Dropdown };
/*==================== Types ====================*/
var justify = {
    left: "left",
    right: "right",
};
var templateObject_1, templateObject_2;
